import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Welcome from '../views/Welcome'
import My from '../views/System/My'
import APIDoc from '../views/APIDoc'
import NoPage from '../views/404'
import AddReadyforTask from '../views/Outbound/AddReadyforTask.vue'

import AddLoadingOrder from '../views/Outbound/AddLoadingOrder.vue'
import AddStorageChange from '../views/StorageChange/AddStorageChange.vue'
import LoadingReview from '../views/Outbound/LoadingReview.vue'
import OutboundOrderSend from '../views/Outbound/OutboundOrderSend.vue'
import OutboundOrderDetail from '../views/Outbound/OutboundOrderDetail.vue'
import AddOutboundOrder from '../views/Outbound/AddOutboundOrder.vue'
import Layout from "../views/Layout/Layout";
const _import = require('@/router/_import_' + process.env.NODE_ENV) //获取组件的方法

import LoginCallbackView from "../views/LoginCallbackView";

import {
    MOBILE_ROUTER
} from "./mobile_router";


// mobile
import weixin from "../views/Weixin/Index";
import weixinCallback from "../views/Weixin/Callback";
import weixinxy from "../views/Weixin/Indexxy";
import weixinCallbackxy from "../views/Weixin/Callbackxy";




Vue.use(Router)

const createRouter = () => new Router({
    mode: 'history',
    //PDA
    //mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
            path: '/404',
            component: NoPage,
            name: 'NoPage',
            meta: {
                title: 'NoPage',
                requireAuth: false,
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/APIDoc',
            component: APIDoc,
            name: 'APIDoc',
            meta: {
                title: 'APIDoc',
                requireAuth: false
            },
            hidden: true
        },
        {
            path: '/',
            component: Welcome,
            name: '首页',
            iconCls: 'fa-home', //图标样式class
            // hidden: true,
            meta: {
                title: '首页',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/Outbound/AddReadyforTask',
            component: AddReadyforTask,
            name: '添加备货任务',

            // hidden: true,
            meta: {
                title: '添加备货任务',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false
            }
        },
        {

            path: '/Outbound/AddLoadingOrder',
            component: AddLoadingOrder,
            name: '新增装车单',

            // hidden: true,
            meta: {
                title: '新增装车单',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false

            }
        },
        {

            path: '/StorageChange/AddStorageChange',
            component: AddStorageChange,
            name: '新增移库单',

            // hidden: true,
            meta: {
                title: '新增移库单',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false

            }
        },
        {
            path: '/Outbound/LoadingReview',
            component: LoadingReview,
            name: '装车单复核',
            // hidden: true,
            meta: {
                title: '装车单复核',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false
            }
        },
        {
            path: '/Outbound/OutboundOrderSend',
            component: OutboundOrderSend,
            name: '确认出库',
            // hidden: true,
            meta: {
                title: '确认出库',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false
            }
        },
        {

            path: '/Outbound/AddOutboundOrder',
            component: AddOutboundOrder,
            name: '新增出库单',

            // hidden: true,
            meta: {
                title: '新增出库单',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false

            }
        },

        {
            path: '/Outbound/OutboundOrderDetail',
            component: OutboundOrderDetail,
            name: '出库详情',
            // hidden: true,
            meta: {
                title: '出库详情',
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                NoNeedHome: true,
                NoTabPage: true,
                keepAlive: false
            }
        },

        {
            path: '/login',
            component: Login,
            name: 'login',
            iconCls: 'fa-address-card', //图标样式class
            meta: {
                title: '登录',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/system/my',
            component: My,
            name: '设置',
            iconCls: 'fa-key',
            meta: {
                title: '设置',
                NoTabPage: false,
                NoNeedHome: false
            },
            hidden: true
        },
        {
            path: "/callback",
            name: "LoginCallbackView",
            component: LoginCallbackView,
            meta: {
                title: '登出',
                NoTabPage: true,
            },
            hidden: true
        },
        {
            path: "/weixin/index",
            name: "weixin",
            component: weixin,
            meta: {
                title: '微信跳转',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: "/weixin/auth",
            name: "weixinCallback",
            component: weixinCallback,
            meta: {
                title: '微信跳转',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: "/weixin/indexxy",
            name: "weixinxy",
            component: weixinxy,
            meta: {
                title: '微信跳转',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: "/weixin/authxy",
            name: "weixinCallbackxy",
            component: weixinCallbackxy,
            meta: {
                title: '微信跳转',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '*',
            hidden: true,
            redirect: {
                path: '/404'
            }
        },
        ...MOBILE_ROUTER
    ]
})

const router = createRouter()

export function filterAsyncRouter(asyncRouterMap) {
    //注意这里的 asyncRouterMap 是一个数组
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.path && !route.IsButton) {
            if (route.path === '/' || route.path === '-') { //Layout组件特殊处理
                route.component = Layout
            } else {
                try {
                    route.component = _import(route.path.replace('/:id', ''))
                } catch (e) {
                    try {
                        route.component = () => import('@/views' + route.path.replace('/:id', '') + '.vue');
                    } catch (error) {
                        console.info('%c 当前路由 ' + route.path.replace('/:id', '') + '.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
                    }
                }
            }
        }
        if (route.children && route.children.length && !route.IsButton) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })

    return accessedRouters
}

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}


router.$addRoutes = (params) => {

    var f = item => {

        if (item['children']) {
            item['children'] = item['children'].filter(f);
            return true;
        } else if (item['isButton']) {
            return item['isButton'] === false;
        } else {
            return true;
        }

    }

    var params = params.filter(f);

    router.addRoutes(params)
}

export default router;